import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel"]

  open() {
    if (this._onKey) return
    this.trigger = document.activeElement
    this.previousOverflow = document.body.style.overflow
    this.overlayTarget.classList.remove("hidden")
    this.overlayTarget.classList.add("flex")
    document.body.style.overflow = "hidden"
    this._onKey = (event) => {
      if (event.key === "Escape") { event.preventDefault(); this.close(); return }
      if (event.key !== "Tab") return
      const controls = this.focusable()
      const first = controls[0] || this.panelTarget
      const last = controls[controls.length - 1] || this.panelTarget
      if (event.shiftKey && (document.activeElement === first || !this.panelTarget.contains(document.activeElement))) {
        event.preventDefault(); last.focus()
      } else if (!event.shiftKey && (document.activeElement === last || !this.panelTarget.contains(document.activeElement))) {
        event.preventDefault(); first.focus()
      }
    }
    document.addEventListener("keydown", this._onKey)
    ;(this.focusable()[0] || this.panelTarget).focus()
  }

  focusable() {
    return [...this.panelTarget.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]')]
      .filter((element) => element.getClientRects().length > 0)
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.classList.remove("flex")
    this.cleanup()
    this.trigger?.focus()
  }

  backdropClick(event) { if (event.target === this.overlayTarget) this.close() }

  cleanup() {
    if (!this._onKey) return
    document.removeEventListener("keydown", this._onKey)
    this._onKey = null
    document.body.style.overflow = this.previousOverflow || ""
  }

  disconnect() { this.cleanup() }
}
